import classie from 'classie'

//helper functions
export function elementIndex(element) {
  //index()
  const siblings = element.parentElement.children
  for (let i = 0; i < siblings.length; i++) {
    if (siblings[i] == element) return i
  }
  return -1
}

export function getAncestor(element, ancestorClass) {
  let parent = element.parentElement
  if (parent && !classie.has(parent, ancestorClass)) {
    parent = getAncestor(parent, ancestorClass)
  }
  return parent
}

export function getChildren(n, skipMe) {
  const r = []
  for (; n; n = n.nextSibling) if (n.nodeType == 1 && n != skipMe) r.push(n)
  return r
}

export function getSiblings(n) {
  return getChildren(n.parentNode.firstChild, n)
}

export function checkMq() {
  return window
    .getComputedStyle(document.querySelector('.main-header'), '::before')
    .getPropertyValue('content')
    .replace(/"/g, '')
    .replace(/'/g, '')
}

export function getTranslateXValue(element) {
  const elementStyle = window.getComputedStyle(element, null)
  const elementTranslate =
    elementStyle.getPropertyValue('-webkit-transform') ||
    elementStyle.getPropertyValue('-moz-transform') ||
    elementStyle.getPropertyValue('-ms-transform') ||
    elementStyle.getPropertyValue('-o-transform') ||
    elementStyle.getPropertyValue('transform')
  let translateValue

  if (elementTranslate.indexOf('(') >= 0) {
    let elTranslate = elementTranslate.split('(')[1]
    elTranslate = elTranslate.split(')')[0]
    elTranslate = elTranslate.split(',')
    translateValue = elTranslate[4]
  } else {
    translateValue = 0
  }

  return Number(translateValue)
}

export function setTransformValue(element, property, value) {
  element.style['-webkit-transform'] = `${property}(${value})`
  element.style['-moz-transform'] = `${property}(${value})`
  element.style['-ms-transform'] = `${property}(${value})`
  element.style['-o-transform'] = `${property}(${value})`
  element.style['transform'] = `${property}(${value})`
}

export function requestAnimationFramePol(callback) {
  !window.requestAnimationFrame ? setTimeout(callback, 250) : requestAnimationFrame(callback)
}

export function debounce(condition, debounceVar, callback) {
  if (condition) {
    debounceVar = true
    requestAnimationFramePol(callback)
  }

  return debounceVar
}

export function timeConverter(timestamp) {
  const a = new Date(timestamp)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const year = a.getFullYear()
  const month = months[a.getMonth()]
  const date = a.getDate()
  const time = `${month} ${date}, ${year}`
  return time
}

export function convertHtmlToText(value) {
  value = value.trim
  value = value.replace(/\n+\s+\n+/g, '\n\n')
  value = value.replace(/\n\n+/g, '\n\n')
  value = value.replace(/\n/g, '<br>')
  value = value.replace(/\s+/g, ' ')

  return value
}

export function convertTextToHtml(value) {
  // Convert `&amp;` to `&`.
  value = value.replace(/&amp;/gi, '&')

  // Replace spaces.
  value = value.replace(/&nbsp;/gi, ' ')
  value = value.replace(/\s+/g, ' ')

  // Remove "<b>".
  value = value.replace(/<b>/gi, '')
  value = value.replace(/<\/b>/gi, '')

  // Remove "<strong>".
  value = value.replace(/<strong>/gi, '')
  value = value.replace(/<\/strong>/gi, '')

  // Remove "<i>".
  value = value.replace(/<i>/gi, '')
  value = value.replace(/<\/i>/gi, '')

  // Remove "<em>".
  value = value.replace(/<em>/gi, '')
  value = value.replace(/<\/em>/gi, '')

  // Remove "<u>".
  value = value.replace(/<u>/gi, '')
  value = value.replace(/<\/u>/gi, '')

  // Tighten up "<" and ">".
  value = value.replace(/>\s+/g, '>')
  value = value.replace(/\s+</g, '<')

  // Replace "<br>".
  value = value.replace(/<br>/gi, '\n')

  // Replace "<div>" (from Chrome).
  value = value.replace(/<div>/gi, '\n')
  value = value.replace(/<\/div>/gi, '')

  // Replace "<p>" (from IE).
  value = value.replace(/<p>/gi, '\n')
  value = value.replace(/<\/p>/gi, '')

  // No more than 2x newline, per "paragraph".
  value = value.replace(/\n\n+/g, '\n\n')

  // Whitespace before/after.
  value = value.trim

  return value
}
